import axiosInstance from "../../apiAxios/axiosInstance";

export const InventoryTransferList = async (payload) => {
  const response = await axiosInstance.post("/admin/warehouse-transfer-list", payload);
  return response.data;
};

export const createInventryTransfer= async (payload) => {
  const response = await axiosInstance.post("/admin/warehouse-transfer-store", payload);
  return response.data;
};

export const ViewInventryDetails = async (payload) => {
  const response = await axiosInstance.post("/admin/warehouse-transfer-show", payload);
  return response.data;
};

export const UpdateWhereHouse = async (payload) => {
  const response = await axiosInstance.post("/admin/warehouses-update", payload);
  return response.data;
};

export const DeleteInventory = async (payload) => {
  const response = await axiosInstance.post("/admin/warehouses-delete", payload);
  return response.data;
};

export const WhereHouseChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/warehouses-status-update",
    payload
  );
  return response.data;
};